import Head from "next/head";
import Link from "next/link";
import React from "react";

const PageNotFound = () => {
  return (
    <>
      <Head>
        <title>
          Page Not Found | Bungalows For Sale | Bungalow Finder | Bungalow for
          Sale
        </title>
      </Head>
      <div className="flex-1">
        <main className="h-screen w-full flex flex-col justify-center items-center bg-gray-100">
          <h1 className="text-9xl font-extrabold text-primary tracking-widest">
            404
          </h1>

          <button className="mt-5">
            <Link  href="/">
              <a className="px-6 py-3 bg-primary text-white">Go Home</a>
            </Link>
          </button>
        </main>
      </div>
    </>
  );
};

export default PageNotFound;
